const styles = {
  container: {
    marginTop: 2,
    padding: 2,
    borderRadius: 2,
    backgroundColor: 'grey.100',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
  metaText: {
    color: 'text.secondary',
  },
  helperText: {
    color: 'text.secondary',
  },
}

export default styles
